<h2 mat-dialog-title>{{this.data.title | translate}}</h2>
<mat-dialog-content class="mat-typography">
  {{this.data.description | translate}}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="warn" [mat-dialog-close]="false">{{'general.no' | translate}}</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{'general.yes' | translate}}</button>
</mat-dialog-actions>
